export default __webpack_public_path__ + "static/media/slot11.a3e62e4f.png";